// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1k9r8"};